module.exports = __webpack_public_path__ + "img/hr-small-gray.86a9c6ce.svg";